import React, { useEffect, useState } from "react";
import "./searchbar.scss";
import { Icon } from "@iconify/react";
import { availablityInFilter, checkAvailability } from "../../utils/ellowutils";

// interface to declare all our prop types
interface Props {
  searchChange?: any;
  onClick?: any;
  filterNumber?: number;
  filtervalues?: any;
  tagClose?: any;
  type?: string;
  filterKey?: any;

}

const SearchBar: React.FC<Props> = ({
  searchChange,
  onClick,
  filterNumber,
  filtervalues,
  tagClose,
  type,
  filterKey,
  
  ...rest
}) => {
  const [filterValues, setFilterValues] = useState<any>();
  const [filternum, setFilternum] = useState<any>();

  useEffect(() => {

    let filter = filtervalues && Object.entries(filtervalues).filter(
        (item) => item[1] !== undefined && item[1] !== "" && item[1]!==null && item[0] !== 'rates' && item[0] !== 'loginId' && item[0] !== 'resourcesToExcludeForJobId'
      )
    setFilterValues(filter);
    findCount(filter)
  }, [filterNumber, filtervalues]);

  const findCount = (filter: any) => {
    let count: number = 0;
    filter && filter.map((item: any) => {
      if(Array.isArray(item[1])){
        item[1].map((newItem: any) => {
          count++
        })
      }else{
        count++
      }      
    })
    setFilternum(count)
  }

  const closetag = (value: any, key?: number) => { 
    let tag = value[0];

    if(tag === 'company' || tag === 'positionName'){
      if(value[1].length > 0){
        
      }
    }
    
    if (key === 0) {
     // delete filtervalues[value][key];
      let deletedValues = filtervalues[value].splice(key,1)      
     // filtervalues = filtervalues && filtervalues.filter(deletedValues)
      if (filtervalues[value].length === 0) {
        delete filtervalues[value]
        
        setFilterValues(filtervalues);
      } else {
        setFilterValues(filtervalues);
      }
    } else if (key) {
     // delete filtervalues[value][key];
     let deletedValues = filtervalues[value].splice(key)
    //  filtervalues = filtervalues && filtervalues.filter(deletedValues)
      setFilterValues(filtervalues);
    } else {
      delete filtervalues[tag]      
    }
    setFilterValues(filterValues.filter((item: any) => item !== value));
    if (filterNumber !== 0) {
      setFilternum((prev:any) => prev - 1 );
    }  
    tagClose(filtervalues);
  }

  return (
    <div className="searchbarWrap">
      <div className="searchArea">
        <div className="searchbar">
          <Icon icon="akar-icons:search"/>
          <input
            type="text"
            placeholder="Search"
            onChange={(e) => searchChange(e.target.value)}
          />

          {!filterKey && <button type="button" onClick={() => onClick(type)} className="filterBtn">
            <Icon icon="icon-park-outline:filter" />
            <span>{filternum ? filternum : 0}</span>
          </button> }
        </div>
        <div className="searchTags">
          {filternum > 0 && "Active filter:"}
          {filterValues && filterValues.map((item: any) => {            
              return (
                <span className="selectTags">
                  {item[1] && item[0] !== "experience" && item[0] !== "range" && item[0] !== "dateWithin" && item[0] !== "availability" && item[0] !== 'rates' && typeof item[1] === "object"
                    ? item[1].map((newItem: any, key: number) => {
                        return (
                          <span className="selectTags">
                            {" "}
                            {newItem}
                            {key < item[1].length && (
                              <Icon
                                icon="eva:close-fill"
                                onClick={() => {  closetag(item[0], key)}}
                              />
                            )}
                          </span>
                        );
                      })
                    : (item[0] !== "experience" && item[0] !== "range" && item[0] !=="dateWithin" && item[0] !== 'availability' && item[0] !== 'rates' && item[0] !=='companyType')
                    ? <div>{item[1]}<Icon icon="eva:close-fill" onClick={() => closetag(item)} /></div>
                      : (item[0] !== "dateWithin" && item[0] !== 'availability' && item[0] !== 'rates'  && item[0] !=='companyType') ? <div>{item[1].from + "-" + item[1].to + " Years"}<Icon icon="eva:close-fill" onClick={() => closetag(item)} /></div> 
                        : (item[0] !== 'availability' && item[0] !== 'rates'  && item[0] !=='companyType') ? <div>Date Range<Icon icon="eva:close-fill" onClick={() => closetag(item)} /></div> :
                          item[0] !== 'rates'  && item[0] !=='companyType' ? <div>{availablityInFilter(item[1])}<Icon icon="eva:close-fill" onClick={() => closetag(item)} /></div> :
                            <div>{'Budget: ' + item[1].min + '-' + item[1].max }<Icon icon="eva:close-fill" onClick={() => closetag(item)} /></div>
                  }
                  
                </span>
              );
            })}
        </div>
      </div>
      
      {filtervalues && filtervalues.dateWithin && <div className="dateDropdown">
        <Icon icon="uil:calender" />{filtervalues && filtervalues.dateWithin && new Date(filtervalues.dateWithin.from).toDateString().slice(3) + " - " + new Date(filtervalues.dateWithin.to).toDateString().slice(3)}
        <Icon icon="akar-icons:chevron-down" />
      </div>}
    </div>
  );
};

export default SearchBar;
